<mat-progress-bar *ngIf="isLoading" class="navigation-progress" color="accent" mode="indeterminate"></mat-progress-bar>
<div *ngIf="!currentUser?.emailVerified" class="verifyEmail">Din epostadress är inte verifierad. <a [routerLink]="['/user/verifyemail']">Mer information</a></div>

<header class="layout" [class.sidenavOpen]="sidenavOpen">
    <app-toolbar *ngIf="fullScreen" [title]="title" [logo]="!toolbarBack" [color]="toolbarColor">
        <app-toolbar-close *ngIf="toolbarClose || toolbarBack" (onClose)="onToolbarClose(false)"></app-toolbar-close>
        <app-toolbar-back *ngIf="toolbarBack" (onBack)="onToolbarClose()"></app-toolbar-back>
    </app-toolbar>
    <app-toolbar *ngIf="!fullScreen">        
        <button type="button" class="notifications" (click)="openNotifications()">
            <mat-icon class="badge-overlap" [matBadge]="currentUser?.notifications" [matBadgeHidden]="currentUser?.notifications===0" matBadgeSize="small" matBadgePosition="above after" matBadgeColor="warn">notifications_none</mat-icon>
        </button>
        
        <img class="user-profile" [src]="currentUser?.image" alt="" />

        <app-toolbar-menu>
            <div class="menu-profile">
                <img [src]="currentUser?.image" alt="" />
                <span>
                    <b>{{currentUser?.name}}</b>
                    <app-upload-field [endpoint]="uploadProfileImageEndpoint" [closeOnComplete]="true" (onComplete)="profileImageUploaded()" i18n="Meny topp|">
                        <button type="button">Byt bild</button>
                    </app-upload-field>
                </span>
            </div>
            <mat-divider></mat-divider>
            <a mat-menu-item [routerLink]="['/admin']" i18n="Meny topp|">Hem</a>
            <a mat-menu-item [routerLink]="['/user/edit']" i18n="Meny topp|">Min profil</a>
            <a mat-menu-item  [routerLink]="['/account']" i18n="Meny topp|">Hantera konto</a>
            <button mat-menu-item (click)="supportOpened=true" i18n="Meny topp|">Support</button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="logout()" i18n="Meny topp|">Logga ut</button>
        </app-toolbar-menu>
    </app-toolbar>
</header>

<main [class.sidenav]="hasSidenav" [class.actions]="hasActions">
    <router-outlet></router-outlet>
</main>

<app-support [(opened)]="supportOpened"></app-support>